/**
 * Backbone.js view for the live-agent widget component which implements "instant chat" using the Salesforce
 * Live Agent facility.
 *
 * User: mgodani
 * Date: 4/15/2014
 */
define(function (require) {
  'use strict';
  var $ = require('jquery'),
    _ = require('underscore'),
    Backbone = require('backbone'),
    LiveAgentSupport = require('common/views/LiveAgentSupport'),
    Const = require('common/Const'),
    Alert = require('common/views/Alert'),
    template_html = require('components/live-agent/templates/LiveVideoSupport.html'),
    template = _.template(template_html);

  return Backbone.View.extend({

    initialize: function () {
      this.toggleButton = null;
      this.startActivated = this.options && this.options.startActivated ? this.options.startActivated : false;
      this.type = this.options && this.options.type ? this.options.type : Const.LIVE_VIDEO_SUPPORT.TYPE_GENERAL;
      this.weemoAvailable = window.chrome ? true : false;
      this.render();
    },

    activate: function () {
      this.toggleButton.trigger("click");
    },

    _loadLiveAgent: function (onlineElementId, offlineElementId) {
      LiveAgentSupport.loadLiveAgent(onlineElementId, offlineElementId);
    },

    render: function () {
      var me = this,
        data = this._prepareData();
      this.$el.append(template(data));

      this.widget = $("#lvs-widget");
      this.toggleButton = $(".lvs-widget-button", me.widget);
      var hiddenImg = $("img.lvs-hidden", me.widget);
      var visibleImg = $("img.lvs-visible", me.widget);
      var box = $(".lvs-box", me.widget);

      if (this.startActivated) {
        visibleImg.show();
        hiddenImg.hide();
        box.show();
      }

      var buttons = $(".lvs-widget-button, .lvs-box-header-close", me.widget);
      buttons.click(function () {
        if (hiddenImg.is(":visible")) {
          visibleImg.show();
          hiddenImg.hide();
          box.show();
        } else {
          hiddenImg.show();
          visibleImg.hide();
          box.hide();
        }
      });

      $('#live-video-support-online').click(function() {
        $(this).hide();
        $('#live-video-support-offline').show();

        setTimeout(me.enableChatButton, oeApp.getData('common').liveAgentButtonIdleTime * 1000);
      });

      this._loadLiveAgent('live-video-support-online', 'live-video-support-offline');
      this.trigger("LiveVideoSupport::render");
      return this;
    },

    enableChatButton: function () {
      $('#live-video-support-online').show();
      $('#live-video-support-offline').hide();
    },

    _addWeemoSupport: function (liveagent) {
      var me = this;
      var demoKey = "b11edfadab57";
      var uidGuest = me.randomString(6, 'abcdefghijklmnopqrstuvwxyz');
      liveagent.addCustomDetail('visitorUid', uidGuest, true);

      var script = document.createElement("SCRIPT");
      script.src = 'https://download.weemo.com/js/webappid/' + demoKey;
      script.type = 'text/javascript';
      script.onload = function () {
        window.weemo = new Weemo(demoKey, uidGuest, "internal", "", "0", "Visitor");
        window.weemo.setDebugLevel(1);
        window.weemo.initialize();

        window.weemo.onCallHandler = function (callObj, args) {
          if (args.type == 'webRTCcall' && args.status == 'incoming') {
            var confirmStr;
            if (callObj.dn !== "undefined" && callObj.dn !== undefined) {
              confirmStr = callObj.dn + ' invites you to video chat';
            } else {
              confirmStr = 'A person invites you to video chat';
            }
            if (confirm(confirmStr)) {
              callObj.accept();
            } else {
              callObj.hangup();
            }
          } else if (args.type == 'webRTCcall' && args.status == 'active') {
            // Active drag and drop function
            var rv = document.getElementById('weemo-remotevideo');
            rv.addEventListener('mousedown', me._dragg.startMoving, false);
            var sv = document.getElementById('weemo-selfview');
            sv.addEventListener('mousedown', me._dragg.startMovingPIP, false);
            window.addEventListener('mouseup', me._dragg.stopMoving, false);
          }
        };
      };
      document.getElementsByTagName("head")[0].appendChild(script);

    },

    _prepareData: function () {
      var data = [];
      var me = this,
        nls = commonConfig.getNLSLanguage();

      data.i18n = i18n;
      data.type = this.type;

      return data;
    },

    _dragg: {
      startMoving: function (evt) {
        document.getElementById('weemo-buttonsbar').style.display = 'none';
        document.body.className = document.body.className + ' userSelectNone';
        evt = evt || window.event;
        var posX = evt.clientX,
          posY = evt.clientY,
          a = document.getElementById('weemo-videobox'),
          divTop = a.style.top,
          divLeft = a.style.left,
          diffX,
          diffY;
        divTop = divTop.replace('px', '');
        divLeft = divLeft.replace('px', '');
        diffX = posX - divLeft;
        diffY = posY - divTop;

        document.onmousemove = function (evt) {
          evt = evt || window.event;
          posX = evt.clientX;
          posY = evt.clientY;
          var aX = posX - diffX,
            aY = posY - diffY;

          this.move('weemo-videobox', aX, aY);
        };
      },
      startMovingPIP: function (evt) {
        document.getElementById('weemo-buttonsbar').style.display = 'none';
        document.body.className = document.body.className + ' userSelectNone';
        evt = evt || window.event;
        var posX = evt.clientX,
          posY = evt.clientY,
          a = document.getElementById('weemo-selfview'),
          divHeight = document.getElementById('weemo-selfview').offsetWidth,
          divWidth = document.getElementById('weemo-selfview').offsetWidth,
          divTop,
          divLeft,
          divBottom = a.style.bottom,
          divRight = a.style.right,
          diffX,
          diffY;

        var style = window.getComputedStyle(a);
        var divBottom = style.getPropertyValue('bottom');
        var divRight = style.getPropertyValue('right');
        var boxWidth = document.getElementById('weemo-videobox').offsetWidth;
        var boxHeight = document.getElementById('weemo-videobox').offsetHeight;

        divBottom = divBottom.replace('px', '');
        divRight = divRight.replace('px', '');
        divTop = (parseInt(boxHeight) - (parseInt(divHeight) + parseInt(divBottom)));
        divLeft = (parseInt(boxWidth) - (parseInt(divWidth) + parseInt(divRight)));

        diffX = posX - divLeft;
        diffY = posY - divTop;
        document.onmousemove = function (evt) {
          evt = evt || window.event;
          posX = evt.clientX;
          posY = evt.clientY;
          var aX = posX - diffX,
            aY = posY - diffY;
          this.movePIP('weemo-selfview', aX, aY, boxWidth, boxHeight);
        };
      },
      stopMoving: function () {
        document.getElementById('weemo-videobox').style.position = 'fixed';
        if (document.getElementById('weemo-buttonsbar')) {
          document.getElementById('weemo-buttonsbar').style.display = 'block';
          this.removeClass(document.body, 'userSelectNone');
          document.onmousemove = function () {
          };
        }
      },
      move: function (divid, xpos, ypos) { // Function to assign the style rules to the element
        var a = document.getElementById(divid),
          minX = (2 * (document.getElementById("weemo-videobox").getBoundingClientRect().width / 3)),
          miny = (2 * document.getElementById("weemo-videobox").getBoundingClientRect().height / 3),
          maxX = (window.innerWidth - (minX / 2)),
          maxy = (window.innerHeight - (miny / 2)),
          moveX = Math.max(-minX, Math.min(xpos, maxX)),
          moveY = Math.max(-miny, Math.min(ypos, maxy));

        a.style.left = moveX + 'px';
        a.style.top = moveY + 'px';
      },
      movePIP: function (divid, xpos, ypos, boxWidth, boxHeight) { // Function to assign the style rules to the element
        var offsets = this.getPos(divid),
          moveX = Math.max(0, Math.min(xpos, (offsets.remoteWidth - offsets.pipWidth))),
          moveY = Math.max(0, Math.min(ypos, (offsets.remoteHeight - offsets.pipHeight)));

        moveX = ((boxWidth) - (moveX + offsets.pipWidth));
        moveY = ((boxHeight) - (moveY + offsets.pipHeight));

        document.getElementById(divid).style.right = moveX + 'px';
        document.getElementById(divid).style.bottom = moveY + 'px';
      },
      getPos: function (el) {
        var divOffsets = document.getElementById(el).getBoundingClientRect(),
          parentOffsets = document.getElementById("weemo-remotevideo").getBoundingClientRect();
        return {
          pipWidth: divOffsets.width,
          pipHeight: divOffsets.height,
          remoteWidth: parentOffsets.width,
          remoteHeight: parentOffsets.height
        };
      },
      removeClass: function (node, cls) {
        if (node && node.className && node.className.indexOf(cls) >= 0) {
          var pattern = new RegExp('\\s*' + cls + '\\s*');
          node.className = node.className.replace(pattern, '');
        }
      }
    },

    randomString: function (length, chars) {
      var result = '';
      for (var i = length; i > 0; --i) {
        result += chars[Math.round(Math.random() * (chars.length - 1))];
      }
      return result;
    }
  });
});



//////////////////
// WEBPACK FOOTER
// ./js/components/live-agent/views/LiveVideoSupport.js
// module id = 713
// module chunks = 26